module.exports = __webpack_public_path__ + "img/Orange_R.7432c8ad.png";